import { useState } from 'react'
import { ENV } from '@shared/config/env'
import { usePlatform } from '@shared/platform'
import { Button } from '@shared/ui/Button'
import { useProfileQuery } from '@entities/user'
import { useAppStore } from '@/store/useAppStore'
import { LinkEmailModal } from '@features/link-email/ui/LinkEmailModal'
import { LinkTelegramWaitModal } from '@features/link-telegram/ui/LinkTelegramWaitModal'
import { generateLinkTelegram } from '@features/link-telegram/api/linkTelegramApi'
import styles from './ProfileLoginMethods.module.css'

/**
 * Блок «Способы входа» в профиле: показывает привязанные email и telegram,
 * а также кнопки привязки в зависимости от сборки (tg/web) и текущих контактов.
 */
export const ProfileLoginMethods = () => {
  const platform = usePlatform()
  const profileFromStore = useAppStore((s) => s.profile)
  const { data } = useProfileQuery(Boolean(profileFromStore))
  const profile = data ?? profileFromStore
  const [linkEmailOpen, setLinkEmailOpen] = useState(false)
  const [waitTgOpen, setWaitTgOpen] = useState(false)
  const [tgError, setTgError] = useState<string | null>(null)

  if (!profile) return null

  const handleLinkTelegram = async () => {
    setTgError(null)
    try {
      const { link } = await generateLinkTelegram()
      platform.openLink(link)
      setWaitTgOpen(true)
    } catch {
      setTgError('Не удалось сгенерировать ссылку. Попробуйте позже.')
    }
  }

  const telegramName = profile.telegram
    ? [profile.telegram.first_name, profile.telegram.last_name].filter(Boolean).join(' ')
    : ''
  const telegramUsername = profile.telegram?.username ? ` (@${profile.telegram.username})` : ''

  return (
    <section className={styles.section}>
      <h3 className={styles.title}>Способы входа</h3>

      <div className={styles.row}>
        <span className={styles.label}>Email</span>
        {profile.email
          ? <span className={styles.value}>{profile.email.email}</span>
          : (
            <div className={styles.notLinked}>
              <span className={styles.muted}>не привязан</span>
              {ENV.IS_TG && (
                <Button variant="secondary" onClick={() => setLinkEmailOpen(true)}>
                  Привязать email
                </Button>
              )}
            </div>
          )}
      </div>

      <div className={styles.row}>
        <span className={styles.label}>Telegram</span>
        {profile.telegram
          ? <span className={styles.value}>{telegramName}{telegramUsername}</span>
          : (
            <div className={styles.notLinked}>
              <span className={styles.muted}>не привязан</span>
              {ENV.IS_WEB && (
                <Button variant="secondary" onClick={handleLinkTelegram}>
                  Привязать Telegram
                </Button>
              )}
            </div>
          )}
        {tgError && <div className={styles.error}>{tgError}</div>}
      </div>

      {linkEmailOpen && <LinkEmailModal onClose={() => setLinkEmailOpen(false)} />}
      {waitTgOpen && <LinkTelegramWaitModal onClose={() => setWaitTgOpen(false)} />}
    </section>
  )
}
